var exports = {
  "uW": "GiftSection.module__section___cmZfNX",
  "xQ": "GiftSection.module__footerContainer___cmZfNX",
  "$P": "GiftSection.module__scrollPromptContainer___cmZfNX",
  "Zq": "GiftSection.module__scrollPromptText___cmZfNX",
  "$O": "GiftSection.module__scrollPromptIcon___cmZfNX",
};

module.exports = exports;
